<template>
    <div>
        <div class="text-h4 font-weight-bold my-4 text-left"
             v-text="$gettext('Please Authenticate')"></div>
        <div class="body-1 mb-6 text-left">
            <span v-if="isLocalMode"
                  v-text="$gettext('Please type in your password to login.')"></span>
            <span v-else-if="isFtpMode"
                  v-text="$gettext('Please type in your ftp credentials.')"></span>
<!--            <span v-else-if="isSupportMode"-->
<!--                  v-text="$gettext('Please type in your credentials.')"></span>-->
        </div>
    </div>
</template>
<script>

import {storeToRefs} from "pinia";
import {useLoginStore} from "@/stores/LoginStore";
import MixinLoginComputed from "@/components/pages/login/MixinLoginComputed";
import {computed} from "vue";

export default {
    name: 'LoginFormHeader',
    setup() {

        let isLocalMode = computed(MixinLoginComputed.computed.isLocalMode)
        let isFtpMode =computed( MixinLoginComputed.computed.isFtpMode)
        let isSupportMode = computed(MixinLoginComputed.computed.isSupportMode)

        const loginStore = useLoginStore()

        const {
            loginMode,
        } = storeToRefs(loginStore);

        return {
            isLocalMode,
            isFtpMode,
            isSupportMode,
            loginMode,
        }

    }
}


</script>
